"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const availability_1 = require("../../../utils/hooks/availability");
const callout_1 = __importStar(require("../../callout"));
const react_i18next_1 = require("react-i18next");
const NoticesHoliday = ({ availability, trans }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const holidayNotice = (0, availability_1.useAvailability)(trans);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: holidayNotice && ((0, jsx_runtime_1.jsx)(callout_1.default, { data: {
                type: holidayNotice.isToday
                    ? callout_1.CalloutType.Alert
                    : callout_1.CalloutType.Warning,
                title: t("holidayHours"),
                message: holidayNotice.message,
            } })) }));
};
exports.default = NoticesHoliday;
